/**
 * Normalises a bookable educator query context into a stable shape for signature
 * comparison, stripping unused schedule fields and de-duplicating/sorting certification ids.
 * @param {object} [queryContext]
 * @returns {object}
 */
export const normaliseQueryContext = (queryContext = {}) => ({
  schedules: (queryContext.schedules ?? []).map(
    ({ dateLocal, startTime, endTime }) => ({
      dateLocal,
      startTime,
      endTime,
    })
  ),
  certificationIds: [...new Set(queryContext.certificationIds ?? [])].sort(
    (firstId, secondId) => firstId - secondId
  ),
  classificationId: queryContext.classificationId ?? null,
  locationId: queryContext.locationId ?? null,
})
